// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-label[data-v-6ade29d3]{width:135px}.gap-7[data-v-6ade29d3]{gap:28px}", ""]);
// Exports
module.exports = exports;
